<template>
  <!-- name: '个人中心-三级页面容器' -->
  <div class="thirdWrap">
    <GoBack
      :title="title"
      :nextPath="$route.query.nextPath"
      :curSelectTab="$route.query.curSelectTab"
    />
    <Matching v-if="title === '可捐衣物匹配' || title === '可捐物品匹配'" :title="title"/>
    <AddressEdit v-if="title.includes('地址')" />
  </div>
</template>

<script>
import GoBack from "@/components/GoBack";
import Matching from "./components/matching.vue";
import AddressEdit from "./components/addressEdit.vue";
export default {
  components: { GoBack, Matching, AddressEdit },
  data() {
    return {
      title: "",
    };
  },
  created() {
    this.title = this.$route.query.title;
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.thirdWrap {
  height: calc(100% - 100px);
  width: 100%;
  text-align: center;
  overflow: hidden;
  padding-bottom: 37px;
}
</style>
